import { useMutation } from 'common/hooks';
import { UseMutationOptions } from 'common/types/Api.type';
import { verifyImageMetaDataApi } from '../files.service';

export const useVerifyImageMetaData = (options: UseMutationOptions = {}) => {
  return useMutation(verifyImageMetaDataApi, options);
};
